import React, {createContext, useContext} from 'react';

const ChatUnreadTrackingContext = createContext(false);

export function ChatUnreadTrackingProvider({
  enabled,
  children,
}: {
  enabled: boolean;
  children: React.ReactNode;
}): JSX.Element {
  return <ChatUnreadTrackingContext.Provider value={enabled}>{children}</ChatUnreadTrackingContext.Provider>;
}

export function useChatUnreadTrackingEnabled(): boolean {
  return useContext(ChatUnreadTrackingContext);
}
